// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var EmailContent$ReactHooksTemplate = require("./emailContent.res.js");
var LogicCondition$ReactHooksTemplate = require("../surveys/LogicCondition.res.js");

function empty(param) {
  return {
          id: undefined,
          name: "",
          priority: 1,
          triggerAction: "",
          enabled: true,
          fromAdress: "",
          toAddress: undefined,
          recipientRoleNames: undefined,
          ccAddress: undefined,
          bccAddress: undefined,
          toDataFieldId: undefined,
          ccDataFieldId: undefined,
          emailContent: EmailContent$ReactHooksTemplate.empty(),
          emailContentInfoId: undefined,
          conditions: /* [] */0
        };
}

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function priority(t) {
  return t.priority;
}

function triggerAction(t) {
  return t.triggerAction;
}

function enabled(t) {
  return t.enabled;
}

function fromAdress(t) {
  return t.fromAdress;
}

function toAddress(t) {
  return t.toAddress;
}

function recipientRoleNames(t) {
  return t.recipientRoleNames;
}

function ccAddress(t) {
  return t.ccAddress;
}

function bccAddress(t) {
  return t.bccAddress;
}

function toDataFieldId(t) {
  return t.toDataFieldId;
}

function ccDataFieldId(t) {
  return t.ccDataFieldId;
}

function emailContent(t) {
  return t.emailContent;
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setPriority(t, priority) {
  return {
          id: t.id,
          name: t.name,
          priority: priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setTriggerAction(t, triggerAction) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setEnabled(t, enabled) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setFromAdress(t, fromAdress) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setToAdress(t, toAddress) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setRecipientRoleNames(t, recipientRoleNames) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setCcAddress(t, ccAddress) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setBccAddress(t, bccAddress) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setToDataFieldId(t, toDataFieldId) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setCcDataFieldId(t, ccDataFieldId) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: ccDataFieldId,
          emailContent: t.emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function setEmailContent(t, emailContent) {
  return {
          id: t.id,
          name: t.name,
          priority: t.priority,
          triggerAction: t.triggerAction,
          enabled: t.enabled,
          fromAdress: t.fromAdress,
          toAddress: t.toAddress,
          recipientRoleNames: t.recipientRoleNames,
          ccAddress: t.ccAddress,
          bccAddress: t.bccAddress,
          toDataFieldId: t.toDataFieldId,
          ccDataFieldId: t.ccDataFieldId,
          emailContent: emailContent,
          emailContentInfoId: t.emailContentInfoId,
          conditions: t.conditions
        };
}

function decodeEmailContentInfo(json) {
  var dict = Js_json.decodeObject(json);
  if (dict === undefined) {
    return EmailContent$ReactHooksTemplate.empty();
  }
  var value = Js_dict.get(dict, "email_content_info");
  if (value === undefined) {
    return EmailContent$ReactHooksTemplate.empty();
  }
  try {
    return EmailContent$ReactHooksTemplate.decode(value);
  }
  catch (exn){
    return EmailContent$ReactHooksTemplate.empty();
  }
}

function decodeConditions(dataFields, json) {
  var items = Json_decode.optional((function (param) {
          return Json_decode.field("notification_conditions", (function (param) {
                        return Json_decode.array((function (x) {
                                      return x;
                                    }), param);
                      }), param);
        }), json);
  if (items !== undefined) {
    return Belt_List.fromArray(Belt_Array.map(items, (function (item) {
                      try {
                        return LogicCondition$ReactHooksTemplate.decode(item, /* [] */0, dataFields);
                      }
                      catch (exn){
                        return LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                                    TAG: "DataField",
                                    _0: DataField$ReactHooksTemplate.empty()
                                  });
                      }
                    })));
  } else {
    return /* [] */0;
  }
}

function decodeNestedDataFieldId(json, key) {
  var match = Json_decode.optional((function (param) {
          return Json_decode.field(key, (function (param) {
                        return Json_decode.optional((function (param) {
                                      return Json_decode.field("id", Json_decode.$$int, param);
                                    }), param);
                      }), param);
        }), json);
  if (match === undefined) {
    return ;
  }
  var id = Caml_option.valFromOption(match);
  if (id !== undefined) {
    return id;
  }
  
}

function decode(dataFields, json) {
  var match = Json_decode.optional((function (param) {
          return Json_decode.field("to_data_field_id", (function (param) {
                        return Json_decode.optional(Json_decode.$$int, param);
                      }), param);
        }), json);
  var toDataFieldId;
  if (match !== undefined) {
    var id = Caml_option.valFromOption(match);
    toDataFieldId = id !== undefined ? id : decodeNestedDataFieldId(json, "to_data_field");
  } else {
    toDataFieldId = decodeNestedDataFieldId(json, "to_data_field");
  }
  var match$1 = Json_decode.optional((function (param) {
          return Json_decode.field("cc_data_field_id", (function (param) {
                        return Json_decode.optional(Json_decode.$$int, param);
                      }), param);
        }), json);
  var ccDataFieldId;
  if (match$1 !== undefined) {
    var id$1 = Caml_option.valFromOption(match$1);
    ccDataFieldId = id$1 !== undefined ? id$1 : decodeNestedDataFieldId(json, "cc_data_field");
  } else {
    ccDataFieldId = decodeNestedDataFieldId(json, "cc_data_field");
  }
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          priority: Json_decode.field("priority", (function (param) {
                  return Json_decode.withDefault(1, Json_decode.$$int, param);
                }), json),
          triggerAction: Json_decode.field("trigger_action", Json_decode.string, json),
          enabled: Json_decode.field("enabled", Json_decode.bool, json),
          fromAdress: Json_decode.field("from_address", Json_decode.string, json),
          toAddress: Json_decode.optional((function (param) {
                  return Json_decode.field("to_addresses", (function (param) {
                                return Json_decode.list(Json_decode.string, param);
                              }), param);
                }), json),
          recipientRoleNames: Json_decode.optional((function (param) {
                  return Json_decode.field("recipient_role_names", (function (param) {
                                return Json_decode.list(Json_decode.string, param);
                              }), param);
                }), json),
          ccAddress: Json_decode.optional((function (param) {
                  return Json_decode.field("cc_addresses", (function (param) {
                                return Json_decode.list(Json_decode.string, param);
                              }), param);
                }), json),
          bccAddress: Json_decode.optional((function (param) {
                  return Json_decode.field("bcc_addresses", (function (param) {
                                return Json_decode.list(Json_decode.string, param);
                              }), param);
                }), json),
          toDataFieldId: toDataFieldId,
          ccDataFieldId: ccDataFieldId,
          emailContent: decodeEmailContentInfo(json),
          emailContentInfoId: Json_decode.optional((function (param) {
                  return Json_decode.field("email_content_info_id", Json_decode.$$int, param);
                }), json),
          conditions: decodeConditions(dataFields, json)
        };
}

function encode(t, deletedConditions) {
  var allConditions = Belt_List.concat(Belt_List.map(t.conditions, (function (c) {
              return LogicCondition$ReactHooksTemplate.toJson(false, c);
            })), Belt_List.map(deletedConditions, (function (c) {
              return LogicCondition$ReactHooksTemplate.toJson(true, c);
            })));
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "priority",
                    t.priority
                  ],
                  tl: {
                    hd: [
                      "trigger_action",
                      t.triggerAction
                    ],
                    tl: {
                      hd: [
                        "enabled",
                        t.enabled
                      ],
                      tl: {
                        hd: [
                          "from_address",
                          t.fromAdress
                        ],
                        tl: {
                          hd: [
                            "to_addresses",
                            Json_encode.nullable((function (param) {
                                    return Json_encode.list((function (prim) {
                                                  return prim;
                                                }), param);
                                  }), t.toAddress)
                          ],
                          tl: {
                            hd: [
                              "recipient_role_names",
                              Json_encode.nullable((function (param) {
                                      return Json_encode.list((function (prim) {
                                                    return prim;
                                                  }), param);
                                    }), t.recipientRoleNames)
                            ],
                            tl: {
                              hd: [
                                "cc_addresses",
                                Json_encode.nullable((function (param) {
                                        return Json_encode.list((function (prim) {
                                                      return prim;
                                                    }), param);
                                      }), t.ccAddress)
                              ],
                              tl: {
                                hd: [
                                  "bcc_addresses",
                                  Json_encode.nullable((function (param) {
                                          return Json_encode.list((function (prim) {
                                                        return prim;
                                                      }), param);
                                        }), t.bccAddress)
                                ],
                                tl: {
                                  hd: [
                                    "to_data_field_id",
                                    Json_encode.nullable((function (prim) {
                                            return prim;
                                          }), t.toDataFieldId)
                                  ],
                                  tl: {
                                    hd: [
                                      "cc_data_field_id",
                                      Json_encode.nullable((function (prim) {
                                              return prim;
                                            }), t.ccDataFieldId)
                                    ],
                                    tl: {
                                      hd: [
                                        "email_content_info_id",
                                        Json_encode.nullable((function (prim) {
                                                return prim;
                                              }), EmailContent$ReactHooksTemplate.id(t.emailContent))
                                      ],
                                      tl: {
                                        hd: [
                                          "notification_conditions_attributes",
                                          Belt_List.toArray(allConditions)
                                        ],
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

exports.empty = empty;
exports.id = id;
exports.name = name;
exports.priority = priority;
exports.setPriority = setPriority;
exports.triggerAction = triggerAction;
exports.enabled = enabled;
exports.fromAdress = fromAdress;
exports.toAddress = toAddress;
exports.recipientRoleNames = recipientRoleNames;
exports.ccAddress = ccAddress;
exports.bccAddress = bccAddress;
exports.toDataFieldId = toDataFieldId;
exports.ccDataFieldId = ccDataFieldId;
exports.emailContent = emailContent;
exports.setName = setName;
exports.setTriggerAction = setTriggerAction;
exports.setEnabled = setEnabled;
exports.setFromAdress = setFromAdress;
exports.setToAdress = setToAdress;
exports.setRecipientRoleNames = setRecipientRoleNames;
exports.setCcAddress = setCcAddress;
exports.setBccAddress = setBccAddress;
exports.setToDataFieldId = setToDataFieldId;
exports.setCcDataFieldId = setCcDataFieldId;
exports.setEmailContent = setEmailContent;
exports.decode = decode;
exports.encode = encode;
/* DataField-ReactHooksTemplate Not a pure module */
